// @ts-nocheck
import BMF from 'browser-md5-file'
import { api_get } from '@/utils/http'
import OSS from 'ali-oss'

const appServer = '/cguardian/api/resource/get-aliyun-token'
const bucket = '17zy-content'
const region = 'oss-cn-beijing'
const downloadHost = 'https://c.17zuoye.cn/'

const getMd5 = (file: File) => {
  return new Promise((resolve) => {
    const bmf = new BMF()

    bmf.md5(file, (err: any, md5: any) => {
      resolve(md5)

      if (err) {
        console.log('err:', err)
      }
    })
  })
}

const getToken = () => {
  return new Promise((resolve) => {
    const url = `${location.protocol}//${location.host}${appServer}`
    const getTokenPromise = api_get(url, {})

    return getTokenPromise.then((result: any) => {
      if (!result.success) return

      const cred = result.data
      const client = new OSS({
        region,
        accessKeyId: cred.AccessKeyId,
        accessKeySecret: cred.AccessKeySecret,
        stsToken: cred.SecurityToken,
        bucket
      })

      resolve({ oss: client })
    })
  }) as Promise<{ oss: any }>
}

function uploadAliyunOss(params: any) {
  const { file, client, updateCheckpoint, cb, filename } = params
  let { tempCheckpoint } = params

  return new Promise((resolve) => {
    let retryTimes = 0
    const MAX_RETRY_TIMES = 20

    // 定义上传方法。
    async function multipartUpload() {
      try {
        // object-key可以自定义为文件名（例如file.txt）或目录（例如abc/test/file.txt）的形式，实现将文件上传至当前Bucket或Bucket下的指定目录。
        const result = await client.multipartUpload(filename, file, {
          progress(p: any, checkpoint: any) {
            // 断点记录点。浏览器重启后无法直接继续上传，您需要手动触发上传操作。
            tempCheckpoint = checkpoint
            updateCheckpoint && updateCheckpoint(checkpoint)
            cb && cb(p)
          },
          checkpoint: tempCheckpoint,
          meta: { year: 2020, people: 'test' }
        })
        return result
      } catch (e) {
        if (retryTimes <= MAX_RETRY_TIMES) {
          retryTimes++
          multipartUpload().then((retData) => {
            console.dir(retData)
            console.log('ossupload retry finish 2')
            retData && retData.name && resolve && resolve(retData) // 成功的时候才resolve
          })
        }
        console.log(e)
      }
    }

    // 开始分片上传。
    multipartUpload().then((retData) => {
      console.dir(retData)
      console.log('ossupload multipartUpload finish 2')
      retData && retData.name && resolve(retData)
    })
  })
}

const isImageFile = (file: File) => {
  return (file.type || '').toLowerCase().startsWith('image')
}

export { getToken, uploadAliyunOss, getMd5, downloadHost, isImageFile }
